import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon relative overflow-hidden" data-id="element-164">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[300px] md:w-[600px] h-[150px] md:h-[300px] bg-gold/5 blur-[80px] md:blur-[120px] rounded-full pointer-events-none" data-id="element-165"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-166">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl lg:text-5xl font-heading font-extrabold text-gold mb-6 md:mb-8 leading-tight" data-id="element-167">
          Tu competencia ya está cerrando los contratos que deberían ser tuyos.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-168">
          <p className="text-white text-base md:text-lg mb-8 md:mb-10 max-w-xl leading-relaxed" data-id="element-169">
            Cada día que pasa sin un sistema propio de leads es dinero que
            pierdes. Agenda tu auditoría gratuita y descubre cuánto puedes
            crecer este mes.
          </p>

          <CTAButton text="VERIFICAR DISPONIBILIDAD EN MI ZONA" scrollTo="contact-form" className="w-full md:w-auto text-sm md:text-lg px-6 md:px-10 py-4 md:py-5" data-id="element-170" />

          <div className="mt-6" data-id="element-171">
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline text-sm font-medium" data-id="element-172">
              O agenda directamente → Agendar en Google Calendar
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}